import { useForm } from 'react-hook-form';
import { useState, useEffect } from 'react';
import { CatalogoService } from '../../../service/CatalogoService';
import { ClientePJService } from '../../../service/ClientePJService';
import { InputComponent } from '../../../components/InputComponent';
import { Panel } from 'primereact/panel';
import { InfoCpj } from '../../../models/cpj/InfoCpj';
import * as generic from '../../../components/Generico';
import { InputActividadEconomica } from '../../../components/ui/Formularios/InputActividadEconomica';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';
import { ProgressSpinner } from 'primereact/progressspinner';

export const InformacionPJ = ({ toast, siCliente, catalogos, next, id, nuevoCliente, permss, soloLectura }) => {

    const esTipoEspecial = ['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa);
    const omodel = new InfoCpj({ proyecto: catalogos?.tcompania?.etiqueta, tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, trigger, setValue } = useForm({ defaultValues, shouldTrim: true, mode: 'onTouched' });
    const clientepjSrv = new ClientePJService();
    const catalogoSrv = new CatalogoService();
    const [ecuador, setEcuador] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ecuadorDD, setEcuadorDD] = useState(false);
    const [ciudadesDD, setCiudadesDD] = useState([]);
    const [siCompania, setSiCompania] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { inDrop, inText, inCalendar, inDropMultiple } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const [tieneAnexos, setTieneAnexos] = useState(false);

    useEffect(() => {
        editarFicha();
        // eslint-disable-next-line
    }, [id]);

    const editarFicha = () => {
        setIsLoading(true);
        clientepjSrv.consultarClientepj(id ?? 0, 'p1').then(res => {
            const cats = catalogos;
            const _clientepj = res.data.clientepj;
            setTieneAnexos(res.data.tiene_anexos || false);
            if (!_clientepj) {
                reset(defaultValues);
                return;
            }
            if (res.data.ciudades) {
                setCiudades(res.data.ciudades);
            }
            if (res.data.ciudades_dd) {
                setCiudadesDD(res.data.ciudades_dd);
            }

            setEcuador(_clientepj.pais?.cat_id === cats?.ecuador?.cat_id);
            setEcuadorDD(_clientepj.pais_dd?.cat_id === cats?.ecuador?.cat_id);

            if (cats?.grupo?.length > 0) {
                setSiCompania(false);
                if (_clientepj.grupo) {
                    _clientepj.grupo = cats.grupo.filter(item => _clientepj.grupo.includes(item.cat_id));
                }
            }

            _clientepj.fecha = generic.stringToDate(_clientepj.fecha);
            _clientepj.fecha_ini_actividad = generic.stringToDate(_clientepj.fecha_ini_actividad);

            nuevoCliente({ id: _clientepj.id, nemonico: _clientepj.nemonico });

            reset(generic.renewValues(_clientepj, omodel.model));
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onChangePais = (e) => {
        setEcuador(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia', null);
        setValue('ciudad', null);
        setCiudades([]);
    }

    const onChangeProvincia = (e) => {
        setValue('ciudad', null);
        if (!e?.value) { setCiudades([]); return; }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
    }

    const onChangePaisDD = (e) => {
        setEcuadorDD(e.value?.cat_id === catalogos.ecuador?.cat_id);
        setValue('provincia_dd', null);
        setValue('ciudad_dd', null);
        setCiudadesDD([]);
    }

    const onChangeProvinciaDD = (e) => {
        setValue('ciudad_dd', null);
        if (!e?.value) { setCiudadesDD([]); return; }
        catalogoSrv.getCatalogosId(e.value.cat_id).then(res => setCiudadesDD(res.data));
    }

    const onSubmit = (data) => {
        data.fecha = data.fecha.toISOString().split('T')[0];
        data.fecha_ini_actividad = data.fecha_ini_actividad.toISOString().split('T')[0];
        data.ec = catalogos.ecuador.cat_id;
        data.ecDD = catalogos.ecuador.cat_id;
        data.paso = 'p1';
        data.grp = catalogos?.grupo?.length ?? 0;
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa ?? null;
        setIsSaving(true);

        if (id == null) {
            clientepjSrv.newClientepj(data).then(res => {
                setIsSaving(false);
                setValue('id', res.data.id);
                nuevoCliente({ id: res.data.id, nemonico: res.data.nemonico });
                trigger('id');
                generic.funcSuccess(res, toast);
                next();
            }).catch(error => {
                setIsSaving(false);
                generic.funcError(error, toast, setError);
            });
        }
        else {
            data.id = id;
            clientepjSrv.editarClientepj(data).then(res => {
                setIsSaving(false);
                generic.funcSuccess(res, toast);
                next();
            }).catch(error => {
                setIsSaving(false);
                generic.funcError(error, toast, setError);
            });
        }
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const reglaValidacion = (val) => {
        return generic.validarIdentificacionEcuador(val, 'IDEN_RUC') || `RUC incorrecto`;
    };

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">
                <Panel header={generic.renderPanelHeader('A', 'DATOS DE LA SOLICITUD', 'pi pi-cog')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {!esTipoEspecial && catalogos?.grupo?.length > 0 &&
                            inDropMultiple('grupo', catalogos?.grupo, { lab: omodel.optionLabel }, (!siCliente && catalogos?.empresas && !id) ? 6 : 12)
                        }
                        {!siCliente && catalogos?.empresas && !id &&
                            inDrop('empresa', catalogos?.empresas, { lab: omodel.optionLabel }, (!esTipoEspecial && catalogos?.grupo?.length > 0) ? 6 : 12)
                        }
                        {inCalendar('fecha', {}, 3)}
                        {inDrop('pais', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePais, val: false }, 3)}
                        {ecuador ? (
                            <>
                                {inDrop('provincia', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvincia, val: false }, 3)}
                                {inDrop('ciudad', ciudades, { lab: omodel.optionLabel }, 3)}
                            </>
                        ) : (
                            inText('canton', { icon: 'pi pi-map-marker' }, 6)
                        )}
                        {siCompania && !esTipoEspecial && inText('compania', { icon: 'pi pi-building' }, 3)}
                        {!esTipoEspecial && inText('proyecto', { icon: 'pi pi-briefcase' }, siCompania ? 3 : 6)}
                        {inDrop('tipo_formulario', catalogos?.tipoFormulario, { lab: omodel.optionLabel }, esTipoEspecial ? 6 : 3)}
                        {inDrop('tipo_solicitante', catalogos?.tipoSolicitante, { lab: omodel.optionLabel }, esTipoEspecial ? 6 : 3)}
                    </div>
                </Panel>
                <Panel header={generic.renderPanelHeader('A.1', 'DATOS GENERALES DEL CLIENTE', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {inText('razon_social', { icon: 'pi pi-id-card' }, 4)}
                        {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-key' }, 3)}
                        {inDrop('nacionalidad', catalogos?.nacionalidad, {
                            lab: omodel.optionLabel,
                            ne: tieneAnexos ? true : undefined,
                            helpText: tieneAnexos ? "Para modificar la nacionalidad, primero debe eliminar los anexos guardados en la sección final." : null
                        }, 3)}
                        {inCalendar('fecha_ini_actividad', {}, 2)}
                        <InputActividadEconomica name="actividad_economica" control={control} modelDef={omodel.model['actividad_economica']} disabled={soloLectura} col={12} />

                        <div className="col-12 mt-2 mb-2">
                            <div className="border-top-1 border-300"></div>
                        </div>

                        {inDrop('pais_dd', catalogos?.pais, { lab: omodel.optionLabel, chn: onChangePaisDD, val: false }, ecuadorDD ? 4 : 6)}
                        {ecuadorDD ? (
                            <>
                                {inDrop('provincia_dd', catalogos?.provincias, { lab: omodel.optionLabel, chn: onChangeProvinciaDD, val: false }, 4)}
                                {inDrop('ciudad_dd', ciudadesDD, { lab: omodel.optionLabel }, 4)}
                            </>
                        ) : (
                            inText('canton_dd', { icon: 'pi pi-map-marker' }, 6)
                        )}

                        {inText('dirreccion_oficina', { icon: 'pi pi-home' }, 12)}
                        {inText('codigo_postal', { icon: 'pi pi-envelope' }, 5)}
                        {inText('telefono_empresa', { icon: 'pi pi-phone' }, 3)}
                        {inText('email_pga_web', { icon: 'pi pi-at' }, 4)}
                    </div>
                </Panel>
                <BottomActionBar onNext={next} loading={isSaving} isReadOnly={soloLectura} />
            </form>
        </>
    );
}
